import { render, staticRenderFns } from "./ObserverLearnerAssignment.vue?vue&type=template&id=c4893928&"
import script from "./ObserverLearnerAssignment.vue?vue&type=script&lang=js&"
export * from "./ObserverLearnerAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports